import { render, staticRenderFns } from "./FinancialYear.vue?vue&type=template&id=2d4962c2&"
import script from "./FinancialYear.vue?vue&type=script&lang=js&"
export * from "./FinancialYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports